// src/components/UI/InputWithIcon.jsx
import React from 'react';
import {
  Flex,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';

const InputWithIcon = ({ icon, value, ...rest }) => {
  const hasValue = value && value.length > 0;

  return (
    <InputGroup>
      <Flex
        w="100%"
        align="center"
        bg="loginInputBg"
        border="1px solid"
        borderColor="loginInputBorder"
        borderRadius="lg"
        transition="border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease"
        _hover={{
          borderColor: 'loginInputBorderHover',
        }}
        _focusWithin={{
          borderColor: 'loginInputBorderFocus',
          boxShadow: '0 0 0 1px var(--chakra-colors-loginInputBorderFocus)',
        }}
        overflow="hidden"
      >
        <Input
          h="3rem"
          border="none"
          outline="none"
          bg="transparent"
          color="loginInputText"
          fontSize="0.9rem"
          pr="3rem"
          _focus={{
            boxShadow: 'none',
          }}
          _placeholder={{ color: 'loginInputPlaceholder' }}
          sx={{
            '&:-webkit-autofill': {
              WebkitTextFillColor: 'var(--chakra-colors-loginInputText)',
              boxShadow: '0 0 0 1000px var(--chakra-colors-loginInputBg) inset',
              caretColor: 'var(--chakra-colors-loginInputText)',
            },
          }}
          value={value}
          {...rest}
        />
        <InputRightElement pointerEvents="none" h="100%">
          <Icon as={icon} color={hasValue ? 'loginInputIcon' : 'loginTextMuted'} />
        </InputRightElement>
      </Flex>
    </InputGroup>
  );
};

export default InputWithIcon;